import { ActivatedRoute, Router } from '@angular/router'
import { Component, OnInit } from '@angular/core'
import { TemplatesService } from '../templates.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { WorksDialogComponent } from 'src/app/pages/works-dialog/works-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { ViewsService } from 'src/app/views/views.service'
import { VersionsService } from 'src/app/pages/versions/versions.service'
import { MixpanelService } from 'src/app/tracking/mixpanel.service'
import { VendorService } from 'src/app/multivendor/vendor.service'

@Component({
  selector: 'app-templates-new',
  templateUrl: './templates-new.component.html',
  styleUrls: ['./templates-new.component.scss']
})
export class TemplatesNewComponent implements OnInit {
  templatesList: Array<any>
  showTemplatesProgress = false

  applyDialogOpen = false
  applyDialogTemplate: any = null
  applyDialogViews: any = null

  constructor(
    private templateService: TemplatesService,
    private router: Router,
    private route: ActivatedRoute,
    public builderService: BuilderService,
    public dialog: MatDialog,
    private viewsService: ViewsService,
    private vendor: VendorService,
    private versions: VersionsService,
    private mixPanel: MixpanelService,
  ) {
    this.templatesList = []
    this.showTemplatesProgress = true
    this.builderService.getProject(String(localStorage.getItem('selectedProject'))).subscribe((project: any) => {
      // Cache the response
      this.builderService.user_type = project.user_type
      this.builderService.cacheProjectReq.response = project
      this.templateService.getTemplates().subscribe((templates) => {
        this.loadTemplates(templates)
        this.showTemplatesProgress = false
        if (window.screen.width > 768) {
          document.querySelector('template-view')?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
        }
      })
    })
  }

  loadTemplates = (templates: Record<string, any>) => {
    for (const key in templates) {
      if (Object.prototype.hasOwnProperty.call(templates, key)) {
        const element = templates[key]
        this.templatesList.push({
          img: element.template_image,
          name: element.template_name,
          views: element.views,
          template_id: element.id || key,
          template_category: element.category
        })
      }
    }
  }

  ngOnInit(): void {}

  selectNewTemplate = (template: any) => {
    const viewsRaw = template.views || {}
    let views: any
    if (this.vendor?.isMultiVendor) {
      views = Object.entries(viewsRaw).reduce((acc: Record<string, any>, [k, v]: [string, any]) => {
        acc[k] = { ...v, allBlocks: Array.isArray(v.allBlocks) ? v.allBlocks.filter((b: any) => b.type !== 'stacksProducts' && b.type !== 'stacksCategories') : v.allBlocks }
        return acc
      }, {})
    } else {
      views = viewsRaw
    }

    if (this.builderService.getTour()) {
      this.builderService.showUpdateProgress = true
      this.viewsService.submitCustomerView(this.builderService.getSelectedProject(), views).subscribe(() => {})
      this.router.navigate(['/'], { relativeTo: this.route })
      return
    }

    this.applyDialogTemplate = template
    this.applyDialogViews = views
    this.applyDialogOpen = true

    this.mixPanel.track('Template Selected', {
      projectid: this.builderService.getSelectedProject(),
      template: template.name
    })
  }

  onApplyDialogConfirmed = () => {
    this.applyDialogOpen = false
    const views = this.applyDialogViews
    const projectId = this.builderService.getSelectedProject()
    this.builderService.showUpdateProgress = true

    this.versions.setVersion(projectId, new Date().toUTCString()).subscribe(() => {
      this.viewsService.submitCustomerView(projectId, views).subscribe(() => {
        this.builderService.showUpdateProgress = false
        if (!this.builderService.standalone) {
          this.viewsService.allViewsFormatter(views, true)
          setTimeout(() => {
            this.builderService.updateProjectWithNewViews()
          }, 500)
        } else {
          this.router.navigate(['/'], { relativeTo: this.route }).then(() => {
            window.location.reload()
          })
        }
      })
    })
  }

  onApplyDialogClosed = () => {
    this.applyDialogOpen = false
    this.applyDialogTemplate = null
    this.applyDialogViews = null
  }

  skipTour = () => {
    this.builderService.setTour(false).subscribe(
      (response) => {
        this.router.navigate(['/'], { relativeTo: this.route })
      },
      (err) => {}
    )
  }

  howItWorksDialog = () => {
    const dialogRef = this.dialog.open(WorksDialogComponent, {
      width: '700px',
      maxWidth: '80%',
      data: { name: 'templates' }
    })

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed')
    })
  }
}
